/** One point of a PnL chart's union timeline: a timestamp plus one value per user series. */
export interface PnlChartDataPoint {
  timestamp: number;
  [userKey: string]: number;
}

/**
 * Collapses the timeline onto fixed `intervalMs` buckets, merging each bucket into
 * one point: latest value per series, timestamp of the bucket's last point.
 *
 * Merged rather than sampled — each pair is priced by its own backend job, so a
 * bucket holds ticks for different pairs and keeping a single tick would erase
 * every series but that tick's pair.
 */
export function downsamplePnlDataPoints(points: PnlChartDataPoint[], intervalMs: number): PnlChartDataPoint[] {
  if (intervalMs <= 0 || points.length <= 2) return points;

  const merged: PnlChartDataPoint[] = [];
  let currentBucket: number | null = null;
  for (const point of points) {
    const bucket = Math.floor(point.timestamp / intervalMs);
    if (bucket === currentBucket) {
      Object.assign(merged[merged.length - 1]!, point);
      continue;
    }
    merged.push({ ...point });
    currentBucket = bucket;
  }
  return merged;
}
